<template>
  <div v-if="data" ref="echars" class="echars-class">
  </div>
</template>

<script>
import mapDataJson from '@/components/salary/info/map.json'
import {formatMoney} from '@/utils/filters'

export default {
  name: "mapEcharts",
  data: () => ({
    chats: undefined,
    data: undefined
  }),
  methods: {
    init(data) {
      this.data = data

      if (!this.data) return

      let _data = []

      let {features} = mapDataJson

      this.data.forEach((item) => {
        let _name = item.provinceName
        _data.push({
          name: features.find(item => item.properties.name.indexOf(_name) !== -1).properties.name,
          value: item.provinceAveMonthSalary,
          id: item.provinceId,
          list: item.cityList
        })
      })

      let _max = Math.max.apply(null, this.data.map(item => item.provinceAveMonthSalary))


      const option = {
        grid: {
          bottom: '0',
          containLabel: true,
        },
        // geo: {
        //   map: "china",
        //   show: false,
        //   emphasis: {
        //     areaColor: "#389BB7",
        //     borderWidth: 0,
        //   },
        // },
        visualMap: {
          left: 'right',
          top: 'top',
          orient: 'horizontal',
          max: _max,
          inRange: {
            color: [
              '#53cac3',
              '#56b1cd',
              '#5993d9',
              '#5a84df',
              '#6236ff',
            ]
          },
          text: ['高', '低'],
          calculable: true,
        },
        tooltip: {
          show: true,
          formatter(params) {

            if (!params.data) {
              return params.name
            }

            let {name, list} = params.data

            let _html = `<span>${name}</span>`

            if (list) {
              list.forEach(item => {
                _html += `<br/><span>${item.cityName}：</span><span>￥${formatMoney(item.cityAveMonthSalary)}</span>`
              })
            } else {
              _html += '<br/><span>暂无</span>'
            }

            return _html
          }
        },
        series: [
          {
            type: 'map',
            // roam: true,
            mapType: 'china',
            data: _data
          }
        ],


      };
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      this.$nextTick(() => {
        this.chats = this.$echarts.init(this.$refs.echars, 'vintage', {renderer: 'canvas'})
        this.$echarts.registerMap("china", mapDataJson)
        this.chats.setOption(option);
        this.chats.resize();
      })
    },
    resize() {
      this.$nextTick(() => {
        if (this.chats) {
          this.chats.resize();
        }
      })
    }
  }
}
</script>

<style scoped>
.echars-class {
  width: 100%;
  height: 100%;
}
</style>
